/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Plugin_Cap_SavedInputs */



/**
* | output |
* | --- |
* | "Overage limit saved." |
*
* @param {Agent_Plugin_Cap_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_cap_saved = /** @type {((inputs?: Agent_Plugin_Cap_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Cap_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Limite de dépassement respectée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschreitungslimit eingespart.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Superamento del limite di spesa rispettato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лимит превышения лимита сохранен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha guardado el límite de exceso de consumo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("超额限额已节省。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("超過限度額は保存されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अतिरिक्त उपयोग सीमा सुरक्षित कर ली गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limite de excesso salvo.")
	return /** @type {LocalizedString} */ ("Overage limit saved.")
});